import { Check, X } from "lucide-react";

const rows = [
  "Études techniques approfondies",
  "Expertise CEE & connaissance des fiches BAR/BAT/IND",
  "Accompagnement administratif complet (dépôt PNCEE)",
  "Bureau d'études partenaire intégré",
  "Réactivité (réponse sous 48 h)",
  "Suivi personnalisé par chargé d'affaires unique",
  "Présence nationale & équipes terrain dédiées",
  "Mesure & vérification IPMVP",
  "Sécurisation de la valorisation CEE",
];

export default function ComparisonTable() {
  return (
    <section data-testid="comparison-table" className="bg-[#F8FAFC] border-y border-black/5">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-24 md:py-32">
        <div className="max-w-3xl mb-14">
          <div className="text-[11px] font-semibold tracking-[0.28em] text-[#10B981] uppercase mb-5">Pourquoi ECONATION</div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F172A] tracking-tight text-balance leading-[1.05]">
            L&apos;écart entre un délégataire CEE et un véritable partenaire technique.
          </h2>
        </div>

        <div className="bg-white rounded-2xl border border-black/[0.06] overflow-hidden shadow-[0_24px_60px_-30px_rgba(15,23,42,0.15)]">
          <div className="grid grid-cols-3 bg-gradient-to-r from-[#0A0F1A] to-[#0F172A] text-white">
            <div className="p-6 md:p-8 col-span-1">
              <div className="text-[11px] uppercase tracking-[0.28em] text-white/50 mb-2">Critère</div>
              <div className="font-display text-sm md:text-base font-medium text-white/90">9 standards qui font la différence</div>
            </div>
            <div className="p-6 md:p-8 text-center border-l border-white/10">
              <div className="text-[11px] uppercase tracking-[0.28em] text-white/50 mb-2">Autres</div>
              <div className="font-display text-sm md:text-base font-medium text-white/70">Acteurs CEE génériques</div>
            </div>
            <div className="p-6 md:p-8 text-center border-l border-white/10 bg-[#10B981]/15">
              <div className="text-[11px] uppercase tracking-[0.28em] text-[#10B981] mb-2">ECONATION</div>
              <div className="font-display text-sm md:text-base font-semibold">L&apos;excellence opérationnelle</div>
            </div>
          </div>

          <div className="divide-y divide-black/[0.06]">
            {rows.map((r, i) => (
              <div key={r} data-testid={`compare-row-${i + 1}`} className="grid grid-cols-3 items-center">
                <div className="p-5 md:p-6 text-[#0F172A] font-medium text-sm md:text-base">{r}</div>
                <div className="p-5 md:p-6 text-center border-l border-black/[0.06]">
                  <X className="inline h-5 w-5 text-[#94A3B8]" />
                </div>
                <div className="p-5 md:p-6 text-center border-l border-black/[0.06] bg-[#10B981]/[0.04]">
                  <Check className="inline h-5 w-5 text-[#10B981]" strokeWidth={2.5} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
